import React from "react";
import { Link } from "gatsby";

const _Link = props => {
  let { className, extraStyle, children, to } = props;

  return (
    <Link className={className} style={extraStyle} to={`${to}`}>
      {children}
    </Link>
  );
};

export default _Link;
